export default "__VITE_ASSET__lV_Y3nOS__"